// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"4126d573","94":"2a94ec56","312":"5118a34f","595":"988143e6","950":"3542c754"}[chunkId] + ".chunk.css";
};